import { render } from "./DouyinMiniappIntroduce.vue?vue&type=template&id=6ea91d1c&scoped=true"
import script from "./DouyinMiniappIntroduce.vue?vue&type=script&lang=js"
export * from "./DouyinMiniappIntroduce.vue?vue&type=script&lang=js"

import "./DouyinMiniappIntroduce.vue?vue&type=style&index=0&id=6ea91d1c&lang=scss&scoped=true"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea91d1c"]])

export default __exports__